import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z"
      fill="#FF73A9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2762 6.39052C18.5262 6.64057 18.6667 6.97971 18.6667 7.33333V15.3333C18.6667 15.687 18.5262 16.0261 18.2762 16.2761C18.0261 16.5262 17.687 16.6667 17.3334 16.6667H13.94C13.7651 16.6674 13.5975 16.7368 13.4734 16.86L12.48 17.8533C12.3864 17.9471 12.2593 17.9999 12.1267 18H11.8734C11.7408 17.9999 11.6137 17.9471 11.52 17.8533L10.5267 16.86C10.4025 16.7368 10.2349 16.6674 10.06 16.6667H6.66671C6.31309 16.6667 5.97395 16.5262 5.7239 16.2761C5.47385 16.0261 5.33337 15.687 5.33337 15.3333V7.33333C5.33337 6.97971 5.47385 6.64057 5.7239 6.39052C5.97395 6.14048 6.31309 6 6.66671 6H17.3334C17.687 6 18.0261 6.14048 18.2762 6.39052ZM13.2357 13.2357C13.2983 13.1732 13.3334 13.0884 13.3334 13V12.3333C13.3334 12.2449 13.2983 12.1601 13.2357 12.0976C13.1732 12.0351 13.0884 12 13 12H8.33337C8.24497 12 8.16018 12.0351 8.09767 12.0976C8.03516 12.1601 8.00004 12.2449 8.00004 12.3333V13C8.00004 13.0884 8.03516 13.1732 8.09767 13.2357C8.16018 13.2982 8.24497 13.3333 8.33337 13.3333H13C13.0884 13.3333 13.1732 13.2982 13.2357 13.2357ZM15.9024 10.569C15.9649 10.5065 16 10.4217 16 10.3333V9.66667C16 9.57826 15.9649 9.49348 15.9024 9.43096C15.8399 9.36845 15.7551 9.33333 15.6667 9.33333H8.33337C8.24497 9.33333 8.16018 9.36845 8.09767 9.43096C8.03516 9.49348 8.00004 9.57826 8.00004 9.66667V10.3333C8.00004 10.4217 8.03516 10.5065 8.09767 10.569C8.16018 10.6315 8.24497 10.6667 8.33337 10.6667H15.6667C15.7551 10.6667 15.8399 10.6315 15.9024 10.569Z"
      fill="white"
    />
  </svg>
);
const SvgTourIndicatorColored = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgTourIndicatorColored;
